import React from 'react';
import PropTypes from 'prop-types';
import urlJoin from 'url-join';
import { getIconUrl } from '.';
import { Link, withRouter } from 'react-router-dom';
import { getImageByWidth } from '../../utils/api';
import CtaButton from '../CtaButton';


const TopicOverview = ({ location, mobileUi, topics }) => (
  <div className="topic-tree-overview-container">
    {topics.map(({ name, slug, icon, shortDescription, overviewImage }) => {
      const { iconDefault } = getIconUrl(icon);
      const linkHref = urlJoin(location.pathname, slug, mobileUi ? '?showOverlay=true' : '');
      const image = overviewImage ? getImageByWidth(overviewImage.previewImages.posterFrame, 800) : null;
      return (
        <div key={slug} className="topic-tree-overview-item">
          {image ? (
            <figure className="mb-4">
              <Link to={linkHref}>
                <img src={image.url} alt={overviewImage.slug} />
              </Link>
            </figure>
          ) : null}
          <div className="d-flex align-items-center mb-3">
            {iconDefault ? (
              <div className="topic-tree-overview-icon">
                <img src={iconDefault} alt="" />
              </div>
            ) : null}
            <h5 className="heading-display text-uppercase m-0">
              <Link to={linkHref}>{name}</Link>
            </h5>
          </div>
          <div className="body-copy description" dangerouslySetInnerHTML={{ __html: shortDescription }} />
          <CtaButton
            small
            text="Explore the Issues"
            textSub={`in ${name}`}
            href={linkHref}
          />
        </div>
      );
    })}
  </div>
);

TopicOverview.propTypes = {
  mobileUi: PropTypes.bool,
  topics: PropTypes.arrayOf(PropTypes.object),
};

export default withRouter(TopicOverview);



// WEBPACK FOOTER //
// ./src/components/TopicTree/TopicOverview.js